// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-blue-theme-color: #83a4cf;
}






.App {
  text-align: center;
  background-color: #fff;
}


.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.container-fluid .mt-3.card.align-items-center {
  border: 0.5px solid lightgray;
}

.disabled-custom {
  pointer-events: none;
  opacity: 0.6;
  cursor: not-allowed;
}

.cursor-pointer {
  cursor: pointer;
}

.custom-Btn-animation {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.custom-Btn-animation:active {
  transform: scale(0.9);
  box-shadow: 0 0 8px rgba(69, 69, 69, 0.2);
}

.fleet-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 28px;
  /* background-color: #85a0d6; */
  color: #ffffff;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.fleet-btn-xs {
  padding: 4px 12px;
  font-size: 12px;
  border-radius: 6px;
}

.fleet-btn-sm {
  padding: 6px 18px;
  font-size: 13px;
  border-radius: 6px;
}

.fleet-btn-md {
  padding: 8px 28px;
  font-size: 15px;
  border-radius: 8px;
}

.fleet-btn-lg {
  padding: 12px 36px;
  font-size: 17px;
  border-radius: 10px;
}

.blue-theme {
  background-color: #85a0d6;
  color: #ffffff;
}
.blue-theme:hover { background-color: #7291cd; }
.blue-theme:disabled { background-color: #b9c6e5; cursor: not-allowed; }

.gray-theme {
  background-color: #9ca3af;
  color: #ffffff;
}
.gray-theme:hover { background-color: #868e9c; }
.gray-theme:disabled { background-color: #d1d5db; cursor: not-allowed; }

.green-theme {
  background-color: #8bc79a;
  color: #ffffff;
}
.green-theme:hover { background-color: #71b382; }
.green-theme:disabled { background-color: #c3e0cb; cursor: not-allowed; }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;AACrC;;;;;;;AAOA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;;AAGA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA,oBAAoB,yBAAyB,EAAE;AAC/C,uBAAuB,yBAAyB,EAAE,mBAAmB,EAAE;;AAEvE;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA,oBAAoB,yBAAyB,EAAE;AAC/C,uBAAuB,yBAAyB,EAAE,mBAAmB,EAAE;;AAEvE;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA,qBAAqB,yBAAyB,EAAE;AAChD,wBAAwB,yBAAyB,EAAE,mBAAmB,EAAE","sourcesContent":[":root {\r\n  --primary-blue-theme-color: #83a4cf;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n.App {\r\n  text-align: center;\r\n  background-color: #fff;\r\n}\r\n\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.container-fluid .mt-3.card.align-items-center {\r\n  border: 0.5px solid lightgray;\r\n}\r\n\r\n.disabled-custom {\r\n  pointer-events: none;\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.custom-Btn-animation {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.custom-Btn-animation:active {\r\n  transform: scale(0.9);\r\n  box-shadow: 0 0 8px rgba(69, 69, 69, 0.2);\r\n}\r\n\r\n.fleet-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 8px 28px;\r\n  /* background-color: #85a0d6; */\r\n  color: #ffffff;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  font-family: inherit;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, transform 0.1s ease;\r\n}\r\n\r\n.fleet-btn-xs {\r\n  padding: 4px 12px;\r\n  font-size: 12px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.fleet-btn-sm {\r\n  padding: 6px 18px;\r\n  font-size: 13px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.fleet-btn-md {\r\n  padding: 8px 28px;\r\n  font-size: 15px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.fleet-btn-lg {\r\n  padding: 12px 36px;\r\n  font-size: 17px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.blue-theme {\r\n  background-color: #85a0d6;\r\n  color: #ffffff;\r\n}\r\n.blue-theme:hover { background-color: #7291cd; }\r\n.blue-theme:disabled { background-color: #b9c6e5; cursor: not-allowed; }\r\n\r\n.gray-theme {\r\n  background-color: #9ca3af;\r\n  color: #ffffff;\r\n}\r\n.gray-theme:hover { background-color: #868e9c; }\r\n.gray-theme:disabled { background-color: #d1d5db; cursor: not-allowed; }\r\n\r\n.green-theme {\r\n  background-color: #8bc79a;\r\n  color: #ffffff;\r\n}\r\n.green-theme:hover { background-color: #71b382; }\r\n.green-theme:disabled { background-color: #c3e0cb; cursor: not-allowed; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
